import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const orig = error.config;
    const skip = /\/auth\/(login|register|refresh)/.test(orig?.url || "");
    if (error.response?.status === 401 && orig && !orig._retry && !skip) {
      orig._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(orig);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return detail.msg || String(detail);
}

import { dateLocale } from "./i18n";

const eurFmt = new Intl.NumberFormat(dateLocale(), { style: "currency", currency: "EUR" });
export const eur = (n) => eurFmt.format(Number(n || 0));
export const fmtDate = (s) => (s ? new Date(s.length === 10 ? `${s}T12:00:00` : s).toLocaleDateString(dateLocale(), { day: "2-digit", month: "short", year: "numeric" }) : "—");

export async function downloadFile(url, params, fallbackName) {
  const res = await api.get(url, { params, responseType: "blob" });
  const match = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "");
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = match ? match[1] : fallbackName;
  a.click();
  URL.revokeObjectURL(href);
}
